import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmployeeService } from '../../employee/services/employee.service';
import { Subscription } from 'rxjs';
import { ActuationService } from '../services/actuation.service';
import { ActuationOperation as ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import { LeaveService } from '../../leave/services/leave.service';
import { MatDialog } from '@angular/material/dialog';
import { EditActuacionesComponent } from '../actuaciones/edit-actuaciones/edit-actuaciones.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { InspectionTypes } from 'app/modules/common/enums/inspection-types';
import { Router } from '@angular/router';
import { ModifyActuationComponent } from './modify-actuation/modify-actuation.component';
import { MarcarAsuenciaJustificadaDialogComponent } from './marcar-asuencia-justificada-dialog/marcar-asuencia-justificada-dialog.component';
import { QuitarAusenciaJustificadaDialogComponent } from './quitar-ausencia-justificada-dialog/quitar-ausencia-justificada-dialog.component';
import { DocumentsService } from '../services/documents.service';
import {
    EditSolicitudDialogComponent,
    EditSolicitudDialogData,
} from './edit-solicitud-dialog/edit-solicitud-dialog.component';
import {
    EditActuationDialogData,
    EditActuationTypeDialogComponent,
} from './edit-actuation-type-dialog/edit-actuation-type-dialog.component';
import {
    CutActuationsDialogComponent,
    CutActuationsDialogData,
} from './cut-actuations-dialog/cut-actuations-dialog.component';
import Utils from 'app/Utils';
export let browserRefresh = false;

@Component({
    selector: 'app-actuaciones',
    templateUrl: './actuaciones.component.html',
    styleUrls: ['./actuaciones.component.scss'],
    standalone: false
})
export class ActuacionesComponent implements OnInit, OnDestroy {
    actuationOperation = ActuationOperation;
    InspectionType = InspectionTypes;
    InspectionTypeList: Array<number> = [
        16010, 16011, 16012, 16013, 16014, 16015, 16016, 16017, 16018, 16019,
    ];
    ActionMoreOptionTypes: Array<number> = [
        13001, 14001, 16010, 16011, 16012, 16013, 16014, 16015, 16016, 16017,
        16018, 16019,
    ];

    actuacionsData: any[] = [];
    showSeemore = false;
    BajaIdLocal: string;
    IsTextoFieldVisible: boolean;
    AllowToCreateActuation = true;
    leaveDetailSubcription: Subscription;
    IsMenuVisible: boolean;
    currentUser: any;
    isLeaveClosed = true;
    
    constructor(
        public actuationService: ActuationService,
        private leaveService: LeaveService,
        public employeeService: EmployeeService,
        private dialog: MatDialog,
        public sharedService: SharedService,
        private documentsService: DocumentsService 
    ) {}

    ngOnInit(): void {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        this.sharedService.setCurrentUserPermissions();
        this.IsMenuVisible = this.sharedService.Permissions.HasPermisos608;
        this.IsTextoFieldVisible =
            this.sharedService.Permissions.HasPermisos505;

        this.actuationService.SubcribeActuations();

        this.leaveDetailSubcription = this.leaveService
            .SubscribeEmployeeLeaveDetails()
            .subscribe(
                (res) => {
                    this.AllowToCreateActuation = !(
                        res &&
                        res.result &&
                        res.result.fAlta
                    );
                    this.isLeaveClosed = res?.result?.fCierre != null;
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    ngOnDestroy(): void {
        this.actuationService.Unsubscribe();
        this.leaveDetailSubcription.unsubscribe();
    }

    clickSeeMore(actuation: any): void {
        if (actuation.showSeemore === undefined) {
            actuation.showSeemore = false;
        } else if (actuation.showSeemore === true) {
            actuation.showSeemore = false;
        } else {
            actuation.showSeemore = true;
        }
        this.ShowCompactText(actuation);
    }

    public ShowCompactText(actuation: any): any {
        const tempActuation = this.actuationService.Actuations.find((x) => x.actuacionId === actuation.actuacionId);
        if (!tempActuation) {
            return ''; 
        }
    
        let displayText = tempActuation.texto;
        let commentText = tempActuation.comentarioParaEmpresa || '';
    
        if (displayText.length > 115 && (actuation.showSeemore === undefined || actuation.showSeemore)) {
            displayText = displayText.substring(0, 114) + '...'; 
        }
    
        if (commentText.length > 115 && (actuation.showSeemore === undefined || actuation.showSeemore)) {
            commentText = commentText.substring(0, 114) + '...';
        }
    
        let finalText = displayText;
        if (commentText) {
            finalText += `<br>Comentario para la empresa: ${commentText}`;
        }
    
        return finalText;
    }
    OpenEditActionText(Action: any): void {
        const ref = this.dialog.open(EditActuacionesComponent);
        ref.componentInstance.ActionId = Action.actuacionId;
        ref.componentInstance.LeaveId = Action.bajaId;
    }

    DeleteActionConfirmation(Action: any): void {
        const ActionId = Action.actuacionId;
        const LeaveId = Action.bajaId;
        const EmployeeDocId = Action.trabajadorId;

        const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmDialogModel(
                'Confirmar acción',
                '¿Eliminar definitivamente esta actuación?'
            ),
        });
        confirmDialog.afterClosed().subscribe((response) => {
            if (response) {
                if (Action.documentoId) {
                    const docConfirmDialog = this.dialog.open(
                        ConfirmationDialogComponent,
                        {
                            data: new ConfirmDialogModel(
                                'Confirmar acción',
                                '¿Esta actuación tiene un documento adjunto. Si se elimina la actuación también se eliminará el documento. ¿Continuar?'
                            ),
                        }
                    );
                    docConfirmDialog.afterClosed().subscribe((docResponse) => {
                        if (docResponse) {
                            this.DeleteAction(ActionId, LeaveId, EmployeeDocId);
                        }
                    });
                } else {
                    this.DeleteAction(ActionId, LeaveId, EmployeeDocId);
                }
            }
        });
    }

    DeleteAction(ActionId: number, LeaveId: number, EmplooyeeID: number): void {
        this.actuationService.DeleteActuation(ActionId).subscribe(
            (res) => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar(
                        'Actuación eliminada con éxito'
                    );
                    this.actuationService.PublishActuations(LeaveId);
                    this.documentsService.PublishDocuments(EmplooyeeID);
                } else {
                    this.sharedService.ShowSnackBar(
                        'No se pudo borrar la actuación'
                    );
                }
            },
            (error) => {
                this.sharedService.ShowSnackBar(
                    'No se pudo borrar la actuación'
                );
                console.error(error);
            }
        );
    }

    /**
     * Open popup to edit actuation
     */
    public EditActuation(Action: any) {
        // open dialog to edit actuation
        this.dialog.open(ModifyActuationComponent, {
            data: {
                actuationId: Action.actuacionId,
                leaveId: Action.bajaId,
            },
        });
    }

    /**
     * Open leave justification dialog
     */
    public OpenMarcarAsuenciaJustificadaDialog(Action: { actuacionId: any }) {
        this.dialog.open(MarcarAsuenciaJustificadaDialogComponent, {
          data: Action.actuacionId,
        });
      }

      public OpenQuitarMarcaAsuenciaJustificadaDialog(Action: { actuacionId: any }) {
        this.dialog.open(QuitarAusenciaJustificadaDialogComponent, {
          data: Action.actuacionId,
        });
      }

    /**
     * Open edit action type dialog
     */
    public openEditActionTypeDialog(actuationId: number) {
        const data: EditActuationDialogData = {
            actuationId,
        };
        const dialog = this.dialog.open(EditActuationTypeDialogComponent, {
            data,
        });
        dialog.afterClosed().subscribe((res: boolean) => {
            if (res) {
                this.actuationService.PublishActuations(
                    this.actuationService.CurrentLeaveId
                );
            }
        });
    }

    /*
     * Open edit Solicitud Dialog
     */
    public openEditSolicitudDialog(actuationId: number) {
        const data: EditSolicitudDialogData = {
            actuationId,
            leaveId: this.actuationService.CurrentLeaveId,
        };
        const dialog = this.dialog.open(EditSolicitudDialogComponent, {
            data,
        });
        dialog.afterClosed().subscribe((res: boolean) => {
            if (res) {
                this.actuationService.PublishActuations(
                    this.actuationService.CurrentLeaveId
                );
            }
        });
    }

    /**
     * Open dialog to cut actions
     */
    public openCutActuationsDialog(actionData) {
        const data: CutActuationsDialogData = {
            actionId: actionData.actuacionId,
            actionFecha: actionData.fecha,
            leaveId: actionData.bajaId,
        };
        this.dialog.open(CutActuationsDialogComponent, {
            data,
        });
    }
}
